<script>
  import PubSub from 'pubsub-js';
  function noop() {};

  export default {
    name: "PTabNav",
    props: {
      tabPanes: {
        type: Array,
        default(){
          return [];
        }
      },
      handTabNavClick: {
        type: Function,
        default(){
          return function () {};
        }
      },
      tabs: {
        type: [String, Number],
        default: ''
      }
    },
    data(){
      return {
        navPrevDisabled: true,
        navNextDisabled: true,
        // 控制左右箭头显示
        scrollable: true,
        listOffset: 0,
        tabsW: this.tabs,
        contentTop: '',
      }
    },
    methods: {
      // 解绑事件
      beforeDestroy() {
        window.removeEventListener('scroll', this.windowScroll);
      },
      // 滚动条距离页面顶部的距离
      windowScroll() {
        // 以下写法原生兼容
          let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          let tabsHeaderTop = this.$refs.tabs_header;
          let tabsContentTop = this.contentTop;
          // console.log(scrollTop);
          // console.log('contentTop',this.contentTop);
          // console.log('tabsHeaderTop', tabsHeaderTop.offsetTop);
          // console.log('tabsContentTop', tabsContentTop.offsetTop);
          if (tabsContentTop.offsetTop >= scrollTop) {
              tabsHeaderTop.classList.remove('p-tabs__header_fixed');
              tabsContentTop.classList.remove('p-tabs__content_h');
          }
          if (scrollTop > tabsHeaderTop.offsetTop) {
              tabsHeaderTop.classList.add('p-tabs__header_fixed');
              tabsContentTop.classList.add('p-tabs__content_h');
          }
          // console.log('tabs_header', this.$refs.tabs_header.offsetTop + 50) ;
      },

      navPrevClickEvent(){
        if(!this.navPrevDisabled){
          let navAnimate = this.$refs.nav_scroll
          let navScrollW = this.$refs.nav_scroll.offsetWidth;
          let navListW = this.$refs.nav_list.offsetWidth;
          let maxTransformX = 0;
          let transformX = this.listOffset - navScrollW;
          // console.log('navAnimate', navAnimate)
          // console.log('navAnimate', navAnimate.scrollLeft)
          // console.log('navScrollW', navScrollW)
          // console.log('navListW', navListW)
          // console.log('maxTransformX', maxTransformX)
          // console.log('transformX', transformX)
          navAnimate.scrollLeft = navAnimate.scrollLeft - 120
          // if(transformX < maxTransformX){
          //   transformX = maxTransformX;
          // }
          // if(transformX === this.listOffset){
          //   return;
          // }
          console.log('上一页按钮点击了', transformX);
          // this.listOffset = transformX;
          if(navAnimate.scrollLeft == 0  ){
            this.navPrevDisabled = true;
            this.navNextDisabled = false;
            console.log('最小')
          }else{
            this.navPrevDisabled = false;
            this.navNextDisabled = false;
          }
          // if(transformX === 0){
          //   this.navPrevDisabled = true;
          //   this.navNextDisabled = false;
          // }else if(transformX === (navListW - navScrollW)){
          //   this.navPrevDisabled = false;
          //   this.navNextDisabled = true;
          // }else{
          //   this.navPrevDisabled = false;
          //   this.navNextDisabled = false;
          // }
        }
      },
      navNextClickEvent(){
        let cHeight = 150 
        if(!this.navNextDisabled){
          let navAnimate = this.$refs.nav_scroll
          let navScrollW = this.$refs.nav_scroll.offsetWidth;
          let navListW = this.$refs.nav_list.offsetWidth;
          let maxTransformX = navListW - navScrollW;
          let transformX = this.listOffset + navScrollW;
          // console.log('navAnimate', navAnimate)
          // console.log('navAnimate', navAnimate.scrollLeft)
          // console.log('navScrollW', navScrollW)
          // console.log('navListW', navListW)
          // console.log('maxTransformX', maxTransformX)
          // console.log('transformX', transformX)
          navAnimate.scrollLeft = navAnimate.scrollLeft + 120
          // if(transformX > maxTransformX){
          //   transformX = maxTransformX;
          // }
          // if(transformX === this.listOffset){
          //   return;
          // }
          // console.log('下一页按钮点击了', transformX);
          // this.listOffset = transformX;
           if(navAnimate.scrollLeft + navScrollW  == navListW ){
            this.navPrevDisabled = false;
            this.navNextDisabled = true;
            // console.log('最大')
          }else{
            // console.log('navNextDisabled', navAnimate.scrollLeft)
            this.navPrevDisabled = false;
            this.navNextDisabled = false;
          }
          // if(transformX === 0){
          //   this.navPrevDisabled = true;
          //   this.navNextDisabled = false;
          // }else if(transformX === (navListW - navScrollW)){
          //   this.navPrevDisabled = false;
          //   this.navNextDisabled = true;
          // }else{
          //   this.navPrevDisabled = false;
          //   this.navNextDisabled = false;
          // }
        }
      },
      // 计算 .p-tabs_nav-list 是否溢出
      calculateListSpilled(){
        let navScrollW = this.$refs.nav_scroll.offsetWidth;
        let navListW = this.$refs.nav_list.offsetWidth;
        if(navScrollW < navListW){
          this.scrollable = true;
        }else{
          if(this.listOffset > 0){
            this.listOffset = 0;
          }
          this.scrollable = false;
        }
      },
      // 滚动条滚动到激活的tab
      scrollToActiveTab(){
        if(this.scrollable){
          this.$nextTick(() => {
            let navListW = this.$refs.nav_list.offsetWidth;   //整宽
            let navAnimate = this.$refs.nav_scroll
            // let navAnimateL
            let navScrollW = this.$refs.nav_scroll.offsetWidth;   //盒子总宽
            let maxTransformX = navListW - navScrollW;
            let navList = this.$refs.nav_list;
            let activeTab = navList.querySelector('.active');
            let activeTabOffsetLeft = 0;
            if(activeTab){
              activeTabOffsetLeft = activeTab.offsetLeft;
            }
            // console.log('滚动条到哪里的距离',navAnimate.scrollLeft)   //滚动条到哪里的距离
            // console.log('maxTransformX',maxTransformX)
            // console.log('整宽', navListW)         //整宽
            // console.log('盒子总宽', navScrollW)       //盒子总宽
            // console.log('选中与盒子的距离', activeTab.offsetLeft)   //选中与盒子的距离
            // console.log('选中当前的宽度', activeTab.offsetWidth)   //选中当前的宽度
            // let navAnimateL = activeTabOffsetLeft + activeTab.offsetWidth - navScrollW 
            // let navAnimateL = activeTab.offsetLeft
            let navAnimateL = activeTab.offsetWidth
            // console.log('navAnimateL', navAnimateL)
            // let transformX = activeTabOffsetLeft + activeTab.offsetWidth - navScrollW;
            // console.log('transformX', transformX)
            // navAnimate.scrollLeft = navAnimateL
            // transformX = transformX < 0 ? 0 : transformX;
            // this.listOffset = transformX;
            if(navAnimateL == 0){
              this.navPrevDisabled = true;
              this.navNextDisabled = false;
            }else{
              this.navPrevDisabled = false;
              this.navNextDisabled = false;
            }
            // if(transformX === 0){
            //   this.navPrevDisabled = true;
            //   this.navNextDisabled = false;
            // }else if(transformX === (navList.offsetWidth - navScrollW)){
            //   this.navPrevDisabled = false;
            //   this.navNextDisabled = true;
            // }else{
            //   this.navPrevDisabled = false;
            //   this.navNextDisabled = false;
            // }
          });
        }
      }
    },
    computed: {
      listOffsetTran(){
        // console.log('dddd',`translateX(-${this.listOffset}px);`)
        return {
          transform: `transition(-${this.listOffset}px)`
        }
      }
    },
    render(h) {
    /*dom结构
    <div class="p-tabs__header is-scrollable">
        <span class="p-tabs__nav-prev disabled"></span>
        <span class="p-tabs__nav-next"></span>
      <div class="p-tabs__nav-scroll">
        <div class="p-tabs_nav-list">
          <div class="p-tabs__nav-item active">全部</div>
          <div class="p-tabs__nav-item disabled">技术教学</div>
          <div class="p-tabs__nav-item">新手教学</div>
        </div>
      </div>
    </div>
    */
      let navPrev = h('span', {
        staticClass: 'p-tabs__nav-prev',
        'class': {
          disabled: this.navPrevDisabled
        },
        on: {
          click: this.navPrevClickEvent
        }
      });
      let navNext = h('span', {
        staticClass: 'p-tabs__nav-next',
        'class': {
          disabled: this.navNextDisabled
        },
        on: {
          click: this.navNextClickEvent
        }
      });
      // 生成标签页
      let navItems = this.tabPanes.map(item => {
        let $labelSlot = item.$scopedSlots.label ? item.$scopedSlots.label() : null;
        let labelContent = $labelSlot ? $labelSlot : item.label;
        return h('div', {
          staticClass: 'p-tabs__item',
          'class': {
            active: this.$parent.currentName === item.name,
            disabled: item.disabled,
          },
          on: {
            click: (e) => {
              this.handTabNavClick(item.name, item, e);
            }
          }
        }, [labelContent]);
      });
      let navScroll = h('div', {
        staticClass: 'p-tabs__nav-scroll',
        ref: 'nav_scroll'
      }, [
        h('div', {
          staticClass: 'p-tabs_nav-list',
          ref: 'nav_list',
          style: this.listOffsetTran
        }, [navItems])
      ]);

      return h('div', {
        staticClass: 'p-tabs__header',
        ref: 'tabs_header',
        'class': {
          'is-scrollable': this.scrollable
        },
      }, [navPrev, navNext, navScroll]);
    },
    updated(){
      this.calculateListSpilled();
    },
    mounted() {
      let that = this  
      PubSub.subscribe('tabsContent',(event,data)=>{
        // console.log('event',event);
        // console.log('data',data);
        that.contentTop = data;
      })
      
      setTimeout(function () {
        window.addEventListener('scroll', that.windowScroll);
      }, 300);
      that.calculateListSpilled();
      // window.addEventListener('scroll', that.navNextClickEvent)
    },
    watch: {
      tabs(val){
        this.tabsW = val;
        // console.log('this.tabsW', this.tabsW);
      }
    },
    destroyed() {
      let that = this
      window.removeEventListener("scroll", that.windowScroll)
    },
    
  }
</script>


// WEBPACK FOOTER //
// src/components/p-tabs/PTabNav.vue